import { createAsyncThunk } from '@reduxjs/toolkit';
import ExamService from '../../services/ExamService';
import GLOBAL from '../../global';
import CONSTANT from '../../constants/Constant';
import { setShowWelcomePage } from '../chat/chatbotSlice';

export const fetchAndInitChatbotNew = createAsyncThunk(
    'chatBotNew/fetchAndInit',
    async (_, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const botData = state.chatBot?.botData || {};
            const invitationId = botData?.invitationId || '';
            const bodyRegionList = botData?.bodyRegionList || [];

            // Show the welcome page while loading
            thunkAPI.dispatch(setShowWelcomePage(true));

            // Step 1: Create assessment
            const createPayload = {
                ProviderEmail: CONSTANT.PROVIDER_EMAIL,
                BodyRegionList: bodyRegionList,
            };
            if (invitationId) {
                createPayload.InvitationId = invitationId;
            }

            const createResponse = await ExamService.createAssessment(createPayload);
            if (!createResponse.success) {
                return thunkAPI.rejectWithValue('Failed to create assessment');
            }

            const assessmentData = createResponse.data;
            GLOBAL.ASSESSMENT = assessmentData;

            const testId = assessmentData?.TestId || '';
            if (!testId) {
                return thunkAPI.rejectWithValue('No TestId returned from createAssessment');
            }

            // Step 2: Fetch all question data
            const editResponse = await ExamService.getEditAssessmentData({ TESTID: testId });
            if (!editResponse.success) {
                return thunkAPI.rejectWithValue('Failed to fetch assessment data');
            }

            thunkAPI.dispatch(setShowWelcomePage(false));
            const tenantFeatures = state.tenantFeatures?.features || {};
            return { testId, message: editResponse.data, tenantFeatures };
        } catch (e) {
            return thunkAPI.rejectWithValue(e?.message || 'Unknown error');
        }
    }
);
